import { useCallback } from 'react';
import { BothUserError, NodeUserError, RailsUserError } from '../errors/errors';

export const useGetErrorMessage = () =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  useCallback((error: any) => {
    if (error instanceof NodeUserError || error instanceof RailsUserError || error instanceof BothUserError) {
      return {
        subTitle: error.message,
      };
    }

    return {
      subTitle: 'Something went wrong',
    };
  }, []);
